<template>
	<div class="pages b-t-1">
		<div>
			<section class="box filter-wapper">
				<div class="fx fx-wrap box-flex">
					<!--<z-select :options="statusItem" v-model="params.status" class="w150" @handleChange="handleOffset(0)"></z-select>-->
				</div>
				<z-search v-model="params.search" placeholder="请输入优惠券名称" @handleSearch="handleOffset(0)"></z-search>
			</section>
			<div>
				<z-table :offset="params.offset" :count="params.count" :total-count="list.item_total" @handleOffset="handleOffset">
					<th slot="columns" v-for="item in columns">{{item}}</th>
					<tr slot="datasource" v-for="(item, index) in list.list || []">
						<td>{{item.title}}</td>
						<td>{{item.reduce_cost | filterMoney}} 元</td>
						<td>满 {{item.least_cost,0 | filterMoney}} 减 {{item.reduce_cost,0 | filterMoney}} 元</td>
						<td>{{item.start_time | momentFmt }} -- {{item.end_time | momentFmt }}</td>
						<td :class="item.status">{{item.status | filterCouponStatus}}</td>
						<td>{{item.c_time | momentFmt}}</td>
						<td class="operating">
							<router-link  class="operat-btn" tag="a" :to="{ name: 'couponDetail',query:{id: item.id}}"><i class="icon-look"></i><span>详情</span></router-link>
							<router-link v-if="item.status == 'WAITING' || item.status == 'DOING'"  class="operat-btn" tag="a" :to="{ name: 'couponEdit',query:{id: item.id}}"><i class="icon-edit"></i><span>编辑</span></router-link>
							<el-popover
							v-if="item.status == 'WAITING' || item.status == 'DOING'"
						  	placement="top"
						  	width="200"
						  	:ref="'popover_'+index"
						  	>
						  		<div class="z-popover">
							  		<div>确定要停用此优惠券?</div>
							  		<div @click="handleClosePopover(index)"  class="pop-btns-cont">
							  			<a class="pop-btn-cancle">取消</a>
							  			<a @click="handleCouponDel(item.id)" class="pop-btn-confirm">确定</a>
							  		</div>
							  	</div>
								<a slot="reference" class="operat-btn"><i class="icon-del"></i><span>停用</span></a>
						  	</el-popover>
						</td>
					</tr>
					<div slot="operate">
						<router-link class="z-btn z-btn-primary b-r-3" :to="{ name: 'couponEdit'}">新增优惠券</router-link>
					</div>
				</z-table>
			</div>
		</div>
	</div>
</template>
<script>
	import {
		mapActions,
		mapState
	} from 'vuex'
	export default {
		name: 'ConponList',
		components: {},
		data() {
			return {
				columns: ['优惠券名称','优惠券面值', '使用条件', '有效期', '优惠券状态','创建时间','操作'],
				params: {
					offset: 0, //分页偏移量
					count: 10, //每页多少条
					search: '',//搜索条件
				}
			}
		},
		mounted() {
			this.handleCouponList()
		},
		/*
		 * 属性计算
		 */
		computed: {
			...mapState({
				list: state => state.coupon.list
			})
		},
		/*
		 * 事件处理
		 */
		methods: {
			//关闭popover
			handleClosePopover(index) {
				if(typeof(this.$refs['popover_' + index]) != "undefined") this.$refs['popover_' + index][0].doClose();
			},
			//获取优惠券列表
			async handleCouponList() {
				await this.couponList(this.params)
			},
			async handleOffset(offset = 0) {
				this.params.offset = offset;
				await this.couponList(this.params);
			},
			async handleCouponDel(id){
				await this.couponDel({id})
				this.$success('操作成功')
				await this.handleCouponList()
			},
			...mapActions(['couponList','couponDel']),
		}
	}
</script>

<style lang="scss" scoped>
	@import "src/assets/css/common.scss";
	table img {
		width: 50px;
		height: 50px;
	}
	
	.pages {
		background: #FFFFFF;
		border: 1px solid #EBEDEE;
    		border-bottom: none;
		.filter-list {
			padding: 1rem;
		}
	}
	
	.table-cont {
		background: $color-white;
	}
	
	.popup-cont {
		width: 400px;
		background: #fff;
		transform-origin: 0 -20%;
		padding: 20px;
		.btn-close {
			position: absolute;
			right: -40px;
			top: -0;
			color: #FF0000;
			cursor: pointer;
			border-radius: 50%;
			i {
				transition: all 0.2s ease;
				font-size: 24px;
				color: #fff;
			}
			&:active {
				i {
					transform: scale(0.8);
					color: #ccc;
				}
			}
		}
		.pic-cont {
			width: 360px;
			height: 512px;
			background: #fff url(../../../../assets/img/code_mould.png) center center no-repeat;
			background-size: 100%;
			#qrcode {
				background: #fff;
				padding: 10px;
				width: 150px;
				height: 150px;
				position: absolute;
				top: 205px;
				left: 125px;
			}
		}
		.btn-down {
			width: 100%;
			background: $color-main;
			border-radius: 5px;
			display: block;
			color: #fff;
			font-weight: bold;
			font-size: 18px;
			text-align: center;
			padding: 10px 0;
			margin-top: 10px;
			transform: translate(0);
			&:active {
				opacity: 1;
				background: darken($color-main, 5%);
				transform: scale(0.95);
			}
		}
	}
	
	table .operating {
		i,
		span {
			width: 68px !important;
		}
	}
	.WAITING{
		color: $color-wrong;
	} 
	.DOING{
		color: $color-success;
	}
	.ENDING{
		color: $color-font-sub;
	}
	.STOP{
		color: $color-font;
	}
</style>


// WEBPACK FOOTER //
// List.vue?77ac09bc